import "core-js/modules/es.array.push.js";
import { WOW } from "wowjs";
import { queryService, idctitle, queryWeakEngineer, queryIsr, queryOperation, cowNewsMainNewsList, queryCount, viewsadd, queryDesign, cowCooperativePartnerGetInfo, cowCooperativePartnerDetailList, queryDesignDetail, getCowVideo } from "../../../request/api.js";
import mobileIndex from "../../mobile/index/index.vue";
const statisticsEnum = [{
  key: "companyEstablishedTime",
  text: "鼎峰成立于"
}, {
  key: "serviceExperience",
  text: "互联网服务经验"
}, {
  key: "ipr",
  text: "自主知识产权"
}, {
  key: "serviceCustomers",
  text: "服务客户"
}];
export default {
  watch: {
    getunderstand(val) {
      this.initMap();
    }
  },
  inject: ["getnavId"],
  components: {
    mobileIndex
  },
  data() {
    return {
      serveId: 2,
      backgroundImage: "",
      images: "",
      queryDesign: [],
      list: [],
      swipew: [],
      weakCurrentEngineering: [],
      systemIntegration: [],
      operation: [],
      journalism: [],
      mainjournalism: [],
      mainjournalismId: null,
      statistics: [],
      cowCooperativePartnerGetInfo: [],
      cowCooperativePartnerDetailList1: [],
      cowCooperativePartnerDetailList2: [],
      queryDesignDetail: [],
      active: "",
      id: null,
      ids: 0,
      itemId: null,
      itemtitle: "",
      designContent: "",
      rdshow: true,
      rdconceal: false,
      jcshow: true,
      jcconceal: false,
      ywshow: true,
      ywconceal: false,
      newVar: [],
      backgroundImg: "",
      designtype: "0",
      swiper: [{
        img: require("../../../assets/pcimg/home_banner_1.png")
      }, {
        image: require("../../../assets/pcimg/home_banner_2.png")
      }],
      servefalg: false,
      animate__flash: '',
      show: true,
      getunderstand: false,
      getCowVideos: ''
    };
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      if (from.path == '/home/allAPP') {
        this.devisetabulation = true;
      } else if (from.path == '/home/APPitem') {
        this.devisedetailed = true;
      }
      next();
    });
  },
  methods: {
    serveget() {
      let serveId = JSON.parse(sessionStorage.getItem("serveId"));
      if (serveId === null) {
        this.serveId = this.serveId;
      } else {
        var serveIds = serveId.toString();
        this.serveId = serveIds;
      }
    },
    servegetid() {
      let deviselist = JSON.parse(sessionStorage.getItem("deviselist"));
      if (deviselist) {
        deviselist;
        this.ids = deviselist.indexs;
        this.itemId = deviselist.itemId;
        this.getqueryDesignDetail();
      }
    },
    initMap() {
      if (this.getunderstand == false) {
        var tcVid = document.getElementById("indextcvideo");
        /* tcVid.onload = function () {
          tcVid.currentTime = 0
          tcVid.load()
        } */
        tcVid.ondispose = function () {
          tcVid.dispose();
        };
      }
    },
    // 获取滚动条位置
    getroll() {
      this.$nextTick(() => {
        var roll = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset;
        localStorage.setItem("roll", roll);
      });
    },
    // 访问首页增加浏览量服务
    getviewsadd() {
      viewsadd().then(res => {});
    },
    getaddmore() {
      this.getroll();
      this.$router.push("/home/addbrand");
    },
    // APPitem跳转
    APPitem(items, itemtitle, itemId, index) {
      if (itemtitle == "海报设计" && itemId == 3 && index == 0) {
        this.getroll();
        sessionStorage.setItem("designindex", 1);
        sessionStorage.setItem("designId", itemId);
        sessionStorage.setItem("designitemtitle", itemtitle);
        /* this.$router.push({
          path: "/home/billAppParticulars"
        }); */
        let {
          href
        } = this.$router.resolve({
          path: '/home/billAppParticulars',
          query: {
            id: itemId
          }
        });
        let page = window.open(href, '_blank');
        setTimeout(function () {
          let icon = 'https://www.jcdfkj.com/img/Slice.c69dd238.png'; // 图片地址
          // page.document.title = "设计_晋城市鼎峰网络科技有限公司"
          const changeFavicon = link => {
            let $favicon = page.document.querySelector('link[rel="icon"]');
            if ($favicon !== null) {
              $favicon.href = link;
            } else {
              $favicon = page.document.createElement("link");
              $favicon.rel = "icon";
              $favicon.href = link;
              page.document.head.appendChild($favicon);
            }
          };
          changeFavicon(icon); // 动态修改网站图标
        }, 100);
      } else {
        this.getroll();
        window.sessionStorage.setItem("jcdfkj_details", JSON.stringify({
          ...items,
          bannerTitle: itemtitle,
          itemId: itemId
        }));
        /* this.$router.push({
          path: "/home/APPitem",
        }); */
        let {
          href
        } = this.$router.resolve({
          path: '/home/APPitem',
          query: {
            id: items.id
          }
        });
        let page = window.open(href, '_blank');
        setTimeout(function () {
          let icon = 'https://www.jcdfkj.com/img/Slice.c69dd238.png'; // 图片地址
          // page.document.title = "设计_晋城市鼎峰网络科技有限公司"
          const changeFavicon = link => {
            let $favicon = page.document.querySelector('link[rel="icon"]');
            if ($favicon !== null) {
              $favicon.href = link;
            } else {
              $favicon = page.document.createElement("link");
              $favicon.rel = "icon";
              $favicon.href = link;
              page.document.head.appendChild($favicon);
            }
          };
          changeFavicon(icon); // 动态修改网站图标
        }, 100);
      }
    },
    // 服务领域标题内容
    async fuwu() {
      return await queryService({
        action: "queryService"
      });
      // .then((res) => {
      //   this.list = res.data.services;
      // });
    },

    enterInto(index) {
      this.id = index;
    },
    getOut() {
      this.id = null;
    },
    // 服务领域跳转
    getserve(serveId) {
      this.getroll();
      if (serveId == 1) {
        window.sessionStorage.setItem("home_nav_index", serveId);
        this.$router.push("/home/customize");
        this.getnavId(1);
      } else if (serveId == 2) {
        window.sessionStorage.setItem("home_nav_index", serveId);
        this.$router.push("/home/template");
        this.getnavId(2);
      } else if (serveId == 3) {
        window.sessionStorage.setItem("home_nav_index", 0);
        this.$router.push("/home/property");
        this.getnavId(3);
      }
    },
    // 公司服务跳转
    getserverun(serveId) {
      if (serveId == 0) {
        this.serveId = 0;
        this.servefalg = true;
        window.sessionStorage.setItem("serveId", this.serveId);
      } else if (serveId == 1) {
        this.serveId = 1;
        this.servefalg = true;
        window.sessionStorage.setItem("serveId", this.serveId);
      } else if (serveId == 2) {
        this.serveId = 2;
        this.servefalg = true;
        window.sessionStorage.setItem("serveId", this.serveId);
      }
    },
    // idc
    async getIdc() {
      return await idctitle({
        action: "queryIdc",
        data: {
          type: 0
        }
      });
      // .then((res) => {
      //   this.swipew = res.data.idcInfos;
      // });
    },

    // 跳转新闻动态
    gengduo() {
      this.getroll();
      this.$router.push("/home/newsActive");
    },
    // idc跳转
    btnidc(e) {
      this.getroll();
      this.getnavId(5);
      window.sessionStorage.setItem("home_nav_index", 5);
      if (e == 0) {
        // 跳转服务器租赁
        this.$router.push("/home/server");
      }
      if (e == 1) {
        // 跳转域名注册
        this.$router.push("/home/domain");
      }
      if (e == 2) {
        // 跳转ssl证书
        this.$router.push("/home/ssl");
      }
    },
    getroll2() {
      let roll = localStorage.getItem("roll");
      roll = roll;
      if (roll) {
        window.scrollTo({
          top: +roll,
          left: 0
          // behavior: "smooth",
        });

        localStorage.removeItem("roll");
      }
    },
    // 设计类型
    async getqueryDesign() {
      return await queryDesign({
        action: "queryDesign",
        data: {
          cowDesignForm: {
            ascField: "sort",
            type: this.designtype
          }
        }
      });
      // .then((res) => {
      //   if (sessionStorage.getItem("designindex") && sessionStorage.getItem("designId") && sessionStorage.getItem("designitemtitle")) {
      //     this.queryDesign = res.data.designInfos;
      //     this.ids = sessionStorage.getItem("designindex")
      //     this.itemId = sessionStorage.getItem("designId")
      //     this.itemtitle = sessionStorage.getItem("designitemtitle")
      //     this.backgroundImg = sessionStorage.getItem("designbackgroundImg")
      //     this.getqueryDesignDetail();
      //   } else {
      //     this.queryDesign = res.data.designInfos;
      //     this.itemId = res.data.designInfos[0].id;
      //     this.itemtitle = res.data.designInfos[0].designTitle;
      //     this.designContent = res.data.designInfos[0].designContent;
      //     this.backgroundImg = res.data.designInfos[0].backgroundImg;
      //     this.getqueryDesignDetail();
      //   }

      // });
    },

    // 设计类型点击
    gettitle(index, itemId, itemtitle, designContent, backgroundImg) {
      this.backgroundImg = backgroundImg;
      this.ids = index;
      this.itemId = itemId;
      this.itemtitle = itemtitle;
      sessionStorage.setItem("designindex", this.ids);
      sessionStorage.setItem("designId", this.itemId);
      sessionStorage.setItem("designitemtitle", this.itemtitle);
      sessionStorage.setItem("designbackgroundImg", this.backgroundImg);
      this.show = !this.show;
      this.animate__flash = ''; //清空样式
      this.$nextTick(function () {
        setTimeout(() => {
          this.animate__flash = "animate__slideInLeft";
        }, 200);
      });
      this.getqueryDesignDetail();
    },
    // 设计首页8个
    getqueryDesignDetail() {
      queryDesignDetail({
        action: "queryDesignDetail",
        data: {
          cowDesignDetailForm: {
            designId: this.itemId,
            page: "1",
            rows: "8",
            ascField: "sort"
          }
        }
      }).then(res => {
        this.queryDesignDetail = res.data.designDetailInfos;
      });
    },
    // 设计查看更多
    getdesignadd() {
      this.getroll();
      window.sessionStorage.setItem("deviselist", JSON.stringify({
        itemId: this.itemId,
        itemtitle: this.itemtitle,
        indexs: this.ids,
        designContent: this.designContent,
        designtype: this.designtype
      }));
      /*  this.$router.push({
         path: "/home/allAPP",
       }); */
      let {
        href
      } = this.$router.resolve({
        path: '/home/allAPP',
        query: {
          id: this.itemId
        }
      });
      let page = window.open(href, '_blank');
      setTimeout(function () {
        let icon = 'https://www.jcdfkj.com/img/Slice.c69dd238.png'; // 图片地址
        // page.document.title = "设计_晋城市鼎峰网络科技有限公司"
        const changeFavicon = link => {
          let $favicon = page.document.querySelector('link[rel="icon"]');
          if ($favicon !== null) {
            $favicon.href = link;
          } else {
            $favicon = page.document.createElement("link");
            $favicon.rel = "icon";
            $favicon.href = link;
            page.document.head.appendChild($favicon);
          }
        };
        changeFavicon(icon); // 动态修改网站图标
      }, 100);
    },
    // 查询弱电工程
    async getqueryWeakEngineer() {
      return await queryWeakEngineer({
        action: "queryWeakEngineer"
      });
      // .then((res) => {
      //   this.weakCurrentEngineering = res.data.weakEngineerInfos[0];
      // });
    },

    // 跳转弱点详情
    getweakCurrent() {
      this.getroll();
      this.$router.push("/home/weakCurrent");
    },
    // 查询集成系统
    async getqueryIsr() {
      return await queryIsr({
        action: "queryIsr"
      });
      // .then((res) => {
      //   this.systemIntegration = res.data.isrInfos[0];
      // });
    },

    // 跳转系统集成详情
    getintegration() {
      this.getroll();
      this.$router.push("/home/integration");
    },
    // 查询运维服务
    async getqueryOperation() {
      return await queryOperation({
        action: "queryOperation"
      });
      // .then((res) => {
      //   this.operation = res.data.operationInfos[0];
      // });
    },

    // 跳转运维详情
    getgetintegration() {
      this.getroll();
      this.$router.push("/home/maintenance");
    },
    // 查询新闻咨询
    async getcowNewsMainNewsList() {
      return await cowNewsMainNewsList({
        action: "cowNewsMainNewsList"
      });
      // .then((res) => {
      //   this.mainjournalism = res.data.cowNewsList[0];
      //   this.journalism = res.data.cowNewsList.slice(1);
      //   this.journalism = this.journalism.slice(0, 3)
      // });
    },

    // 跳转新闻详情
    getjournalism(e) {
      this.getroll();
      let id = e;
      window.sessionStorage.setItem("newid_index", JSON.stringify({
        newsTypeid: id
      }));
      /* this.$router.push({
        path: "/home/newsDetails",
        query:{
            id:id
        }
      });
      */
      let {
        href
      } = this.$router.resolve({
        path: '/home/newsDetails',
        query: {
          id: id
        }
      });
      let page = window.open(href, '_blank');
      setTimeout(function () {
        let icon = 'https://www.jcdfkj.com/img/Slice.c69dd238.png'; // 图片地址
        // page.document.title = "设计_晋城市鼎峰网络科技有限公司"
        const changeFavicon = link => {
          let $favicon = page.document.querySelector('link[rel="icon"]');
          if ($favicon !== null) {
            $favicon.href = link;
          } else {
            $favicon = page.document.createElement("link");
            $favicon.rel = "icon";
            $favicon.href = link;
            page.document.head.appendChild($favicon);
          }
        };
        changeFavicon(icon); // 动态修改网站图标
      }, 100);
    },
    // 查询网站统计
    getqueryCount() {
      queryCount({
        action: "queryCount"
      }).then(res => {
        this.tongjis = res.data.countInfos;
        let newVar = this.tongjis[0];
        const statisticsList = [];
        statisticsEnum.forEach(item => {
          if (newVar[item.key] != null && newVar[item.key] > 10000) {
            statisticsList.push({
              number: `${newVar[item.key]}`.substring(0, `${newVar[item.key]}`.length - 4),
              companyIsShow: true,
              text: item.text
            });
          } else {
            statisticsList.push({
              number: newVar[item.key],
              companyIsShow: false,
              text: item.text
            });
          }
        });
        this.statistics = statisticsList;
      });
    },
    // 合作伙伴文本
    async getcowCooperativePartnerGetInfo() {
      return await cowCooperativePartnerGetInfo({
        action: "cowCooperativePartnerGetInfo",
        data: {
          id: "1"
        }
      });
      // .then((res) => {
      //   this.cowCooperativePartnerGetInfo = res.data.cowCooperativePartner;
      // });
    },

    // 合作伙伴查询
    async getcowCooperativePartnerDetailList() {
      return await cowCooperativePartnerDetailList({
        action: "cowCooperativePartnerDetailList",
        data: {
          cowCooperativePartnerDetailForm: {
            page: "1",
            rows: "10000",
            ascField: "sort"
          }
        }
      });
      // .then((res) => {
      //   this.cowCooperativePartnerDetailList1 =
      //     res.data.cowCooperativePartnerDetailList.slice(0, 9);
      //   this.cowCooperativePartnerDetailList2 =
      //     res.data.cowCooperativePartnerDetailList.slice(10, 22);
      // });
    },

    // 首页视频
    getCowVideo() {
      getCowVideo({
        action: "getCowVideo",
        data: {
          type: "0"
        }
      }).then(res => {
        this.getCowVideos = res.data.cowVideo.video;
      });
    },
    windowScroll() {
      const topDistance = window.innerHeight - (this.$refs.statisticsRef.offsetTop - window.pageYOffset) - this.$refs.statisticsRef.offsetHeight;
      if (topDistance > -300) {
        window.removeEventListener("scroll", this.windowScroll);
        this.getqueryCount();
      }
    }
  },
  mounted() {
    const ISMOBILE = function () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    };
    window.addEventListener("scroll", this.windowScroll);
    const requestList = [this.fuwu(), this.getIdc(), this.getqueryWeakEngineer(), this.getqueryIsr(), this.getqueryOperation(), this.getcowNewsMainNewsList(), this.getqueryDesign(), this.getcowCooperativePartnerGetInfo(), this.getcowCooperativePartnerDetailList()];
    Promise.all(requestList).then(res => {
      const [services, idcInfos, weakCurrentEngineering, systemIntegration, operation, cowNewsList, designInfos, cowCooperativePartner, cowCooperativePartnerDetailList] = res;
      this.list = services.data.services;
      this.swipew = idcInfos.data.idcInfos;
      this.weakCurrentEngineering = weakCurrentEngineering.data.weakEngineerInfos[0];
      this.systemIntegration = systemIntegration.data.isrInfos[0];
      this.operation = operation.data.operationInfos[0];
      this.mainjournalism = cowNewsList.data.cowNewsList[0];
      this.journalism = cowNewsList.data.cowNewsList.slice(1).slice(0, 3);
      const sessionDesignIndex = sessionStorage.getItem("designindex");
      const sessionDesignId = sessionStorage.getItem("designId");
      const sessionDesignItemTitle = sessionStorage.getItem("designitemtitle");
      if (sessionDesignIndex && sessionDesignId && sessionDesignItemTitle) {
        this.queryDesign = designInfos.data.designInfos;
        this.ids = sessionStorage.getItem("designindex");
        this.itemId = sessionStorage.getItem("designId");
        this.itemtitle = sessionStorage.getItem("designitemtitle");
        this.backgroundImg = sessionStorage.getItem("designbackgroundImg");
        this.getqueryDesignDetail();
      } else {
        this.queryDesign = designInfos.data.designInfos;
        this.itemId = designInfos.data.designInfos[0].id;
        this.itemtitle = designInfos.data.designInfos[0].designTitle;
        this.designContent = designInfos.data.designInfos[0].designContent;
        this.backgroundImg = designInfos.data.designInfos[0].backgroundImg;
        this.getqueryDesignDetail();
      }
      this.cowCooperativePartnerGetInfo = cowCooperativePartner.data.cowCooperativePartner;
      this.cowCooperativePartnerDetailList1 = cowCooperativePartnerDetailList.data.cowCooperativePartnerDetailList.slice(0, 9);
      this.cowCooperativePartnerDetailList2 = cowCooperativePartnerDetailList.data.cowCooperativePartnerDetailList.slice(10, 22);
      this.$nextTick(() => {
        const myVid = document.getElementById("indexvideo");
        //标记首页视频
        console.log('ISMOBILE', ISMOBILE);
        !ISMOBILE() && myVid.play();
        // this.$nextTick(() => {
        //   console.log(88888);
        //   myVid.oncanplay = function () {
        //     console.log();
        //     myVid.play()
        //   }
        // })
        this.serveget();
        setTimeout(() => {
          this.getroll2();
          const wow = new WOW({
            boxClass: "wow",
            // default
            animateClass: "animated",
            // default
            offset: 400,
            // default
            mobile: true,
            // default
            live: false
          });
          wow.init();
        }, 300);
      });
    });
    this.getviewsadd();
    this.getCowVideo();
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
  }
};